import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { InvoiceReport } from '../../../components/reports/InvoiceReport/InvoiceReport';

export const InvoiceReportPage = () => {
  return (
    <Layout>
      <h1 id="primaryPageTitle">Invoice Report</h1>
      <InvoiceReport />
    </Layout>
  );
};
